import { RouteContextWrapper } from "@/components/custom/providers/routeContextWrapper";

export default function SettingsAdminSkillCreatePage() {
  return (
    <RouteContextWrapper
      resolvedParams={{ caseId: "default" }}
      resolvedSearchParams={{}}
      settingsView="admin-skills-create"
    />
  );
}
